import { Link } from 'gatsby';
import React, { useState } from 'react';
import CloseButton from '../components/CloseButton';
import Nav from './Nav';

export const Header = ({ location }) => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const showSideMenu = () => {
    isSideMenuOpen ? setIsSideMenuOpen(false) : setIsSideMenuOpen(true);
  };
  return (
    <div
      className={`relative ${
        location && location.pathname === '/'
          ? 'shadow' //only add shadow on home page
          : location?.pathname === '/why-jeetar' ||
            location?.pathname === '/why-jeetar/' ||
            location?.pathname === '/why-jeetar/#FAQ'
          ? 'bg-kYellow'
          : ''
      }`}>
      <header className='max-w-[1150px] w-full mx-auto relative flex flex-row p-10 lg:py-5 py-3 justify-between items-center'>
        <Link
          to='/'
          className='flex items-center lg:space-x-5 space-x-2   leading-10 lg:text-[32px] text-xl'
          data-aos='fade'
          data-aos-delay='10'
          data-aos-duration='1000'>
          <img
            src={'/images/logo.svg'}
            className='w-5 lg:w-7'
            alt='logo'
            data-aos='fade-down'
            data-aos-delay='10'
            data-aos-duration='1000'
          />
          <span
            className='text-kBlue text-pusia-db'
            data-aos='fade-down'
            data-aos-delay='10'
            data-aos-duration='1000'>
            jeetar
          </span>
        </Link>
        <Nav />
        <div
          id='burgerToggle z-100'
          className='block cursor-pointer sm:hidden'
          onClick={showSideMenu}>
          {!isSideMenuOpen ? (
            <div className='menu-icon'>
              <div className='my-1 border-2 w-7 border-JeetarBlack'></div>
              <div className='my-1 border-2 w-7 border-JeetarBlack'></div>
              <div className='my-1 border-2 w-7 border-JeetarBlack'></div>
            </div>
          ) : (
            <CloseButton className='w-7 h-7' />
          )}
        </div>
        {isSideMenuOpen ? <SideMenu /> : ''}
      </header>
    </div>
  );
};

const SideMenu = () => {
  return (
    <div
      className='absolute left-0 z-50 w-full py-5 pl-10 -mt-12 text-white top-28 bg-kBlue sm:hidden'
      data-aos='fade-down'
      data-aos-delay='10'
      data-aos-duration='1000'>
      <div className=''>
        <nav className='flex flex-col space-y-5'>
          <Link to='/'>Home</Link>
          <Link to='/#coverage-cities'>Locations</Link>
          <Link
            to='/why-jeetar/'
            className='flex items-center space-x-2 cursor-pointer'>
            <span className=''> Partner with us</span>
            {/* <img src={'/images/arrow-down.svg'} className='' alt='arrow-down' /> */}
          </Link>
          <Link to='/why-jeetar#FAQ'>FAQs</Link>
          <Link to='/#footer'>Contact us</Link>
        </nav>
      </div>
    </div>
  );
};
